import { Box, Grid } from '@material-ui/core';
import React from 'react';
import { required, TextInput } from 'react-admin';
import useStyles from '../../QuickActions/styles';

const VINForm = () => {
  const classes = useStyles();

  return (
    <Box>
      <Grid
        container
        spacing={1}
        className={`${classes.formRoot} ${classes.width100}`}
      >
        <Grid item xs={12} sm={6} md={4}>
          <TextInput source="vin.vin" label="VIN" validate={[required()]} />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextInput source="vin.color" label="Color" />
        </Grid>
      </Grid>
    </Box>
  );
};

export default VINForm;
